export default __webpack_public_path__ + "static/media/contactsTwitter.8f2a6a03.svg";